import { VueModule } from '@Foundation/utilities';
import CookieBanner from './code/Scripts/components/cookie-banner.vue';

export default VueModule({
  components: {
    CookieBanner
  }
});
